import {ContactRelationType} from "../../libs/enum/contact-relation-type.enum";
import {ContactType} from "../../libs/enum/contact-type";

export class ContactRelationDto {

  public id!: string;
  public type!: ContactRelationType;
  public label: string | undefined;
  public parentId!: string;
  public childId!: string;
  public bidirectionalType!: ContactRelationType;
  public readonly bidirectionalId!: string;
  public readonly childType!: ContactType;
  public readonly childNumber!: string;
  public readonly childFullName!: string;

  constructor(init?: Partial<ContactRelationDto> | undefined) {
    Object.assign(this, init);
  }

  public isEditable(): boolean {
    return true;
  }
}
